import * as React from 'react';
import { GridCell } from '@progress/kendo-react-grid';
import { Link } from 'react-router-dom';
import { IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import * as Crypto from 'crypto-js';
import {DATA_SECRET} from './../../constants/constants';

export default class EditUserButton extends GridCell {

    constructor(props: any) {
        super(props);

    }


    render() {
        const encryptedUserId = Crypto.AES.encrypt(JSON.stringify(this.props.dataItem.id), DATA_SECRET);  
        return (
            <td className="actions editUser">
                <Link to={{ pathname: `/edituser/${encryptedUserId}` }}>
                    <IconButton className="EditItem" title="Edit User">
                        <EditIcon />
                    </IconButton>
                </Link>
            </td>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/users/EditUserButton.tsx